import React, { FC } from 'react';
import { Button } from '@clearcover/atlas';

import { GetDetailsResponseType } from 'QuoteApp/services/endpoints/GetDetails';
import { Spinner } from 'Shared/components';

import styles from './styles.module.css';

type StatusCardProps = {
  isBound: boolean;
  details: GetDetailsResponseType;
  policyNumber?: string | null;
  pollingTimedOut: boolean;
  onResumePolling: () => void;
};

export const StatusCard: FC<StatusCardProps> = ({
  isBound,
  details,
  policyNumber,
  pollingTimedOut,
  onResumePolling,
}) => (
  <div className={styles.statusCard}>
    <h1 className={styles.heading}>
      {isBound ? 'Payment complete!' : 'Payment pending'}
    </h1>

    {isBound ? (
      <p className={styles.subtitle}>The policy has been created.</p>
    ) : pollingTimedOut ? (
      <p className={styles.subtitle}>
        Payment is taking longer than expected. Click below to continue check
        status.
      </p>
    ) : (
      <div className={styles.pendingStatus}>
        <Spinner type="blue" variant="small" />
        <span className={styles.pendingLabel}>
          Customer is completing checkout
        </span>
      </div>
    )}

    <div className={styles.policyInfo}>
      <div className={styles.policyDetail}>
        <span className={styles.label}>Policy Number:</span>{' '}
        <span className="fs-exclude">
          {isBound && policyNumber ? policyNumber : 'not available'}
        </span>
      </div>
      <div className={styles.policyDetail}>
        <span className={styles.label}>Effective:</span>{' '}
        <span className="fs-exclude">
          {details.effectiveDate.value}
          {details.terminationDate.value
            ? ` - ${details.terminationDate.value}`
            : ''}
        </span>
      </div>
    </div>

    {!isBound && pollingTimedOut && (
      <Button
        variant="secondary"
        size="md"
        onClick={onResumePolling}
        className={styles.checkStatusButton}
        data-testid="check-status-button"
      >
        Check Status
      </Button>
    )}
  </div>
);
